import reducerGenerator from "../reducerGenerator";
import {PTO_ENABLED_SET, PTO_EXCEPTION_USERS_SET, PTO_MINIMAL_VALUE_SET, PTO_USER_EXCEPTION_TYPE_SET} from "./actionTypes";

const createReducer = ({
    LOW_BALANCE_SETTINGS = {PTO: {}, SDB: {}},
}) => {
    return reducerGenerator({
        actions: {
            ENABLED_SET: PTO_ENABLED_SET,
            MINIMAL_VALUE_SET: PTO_MINIMAL_VALUE_SET,
            EXCEPTION_USERS_SET: PTO_EXCEPTION_USERS_SET,
            USER_EXCEPTION_TYPE_SET: PTO_USER_EXCEPTION_TYPE_SET,
        },
        initialState: LOW_BALANCE_SETTINGS.PTO
    })
}

export default createReducer


// WEBPACK FOOTER //
// ./web/js/administration/lowBalanceSettings/pto/reducer.js